<template id="cmsForm">    
    <div>                
        <div class="row">
            <div class="col-md-10">
                <h3>Menu Category (<span v-if="item_id">แก้ไข</span><span v-if="!item_id">เพิ่มใหม่</span>)</h3>
            </div>
        </div>
        <form>
            <div class="row">                
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="post_tag_name">ชื่อ Category</label>
                        <input type="text" class="form-control" id="post_tag_name" v-model="form.name">                        
                        <form-error :isError="validateError.name.error" :errorMessage="validateError.name.message"></form-error>
                    </div>
                </div>
                
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="post_status">ปิดการใช้งาน</label>
                        <select class="form-control" id="post_status" v-model="form.disabled">
                            <option :value=0>ไม่</option>
                            <option :value=1>ใช่</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group float-right">
                        <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;" class="btn btn-secondary">ยกเลิก</a>
                        <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">บันทึก</button>
                        <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">บันทึก และ บันทึกเพิ่ม</button>
                    </div>
                </div>
            </div>
        </form>        
    </div>
</template>

<script>
    export default {
        props:{
            //item_id ถูกส่งผ่านมาทาง form.blade.php ใน tag component (:item_id="{{empty($id) ? '0' : $id}}")
            //กรณีที่เป็น การ add item_id จะ เท่ากับ 0
            item_id:'', 
        },
        data() {                        
            return {                
                form:{ 
                    //ชื่อฟิลด์ต่างๆในฟอร์มที่จะ add หรือ edit ชื่อฟิลด์จะเหมือนกับใน postman
                    name:'',
                    disabled:0,
                },
                validateError:{ 
                    // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
                    name:{error:false,message:''},
                },
                languages:{ 
                    // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel                                    
                },
                base_url:'/menu_category', // base url (เปลี่ยน)                
            }
        },        
        mounted() {},
        beforeMount(){},
        created(){            
            if(this.item_id){ //ถ้าเป็นการแก้ไข ให้ไปดึงข้อมูลเดิมมาใส่ฟอร์มด้วยฟังก์ชั่น load(this.item_id)
                this.load(this.item_id);
            }
        },
        methods:{
            load(id){
                axios.get(this.base_url+'/'+id).then(response => {
                    console.log(response.data);
                    //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
                    this.form.name = response.data.post_tag[0].name;
                    this.form.disabled = response.data.post_tag[0].disabled;
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            saveWithGoBack(){
                this.save('');
            },            
            saveWithMore(){
                this.save('more');                
            },
            save(whatNext){
                let save_url = '';
                if(this.item_id!=''){
                    save_url = this.base_url+'/'+this.item_id+'/update';
                }else{
                    save_url = this.base_url;
                }
                let me = this; 
                // console.log(this.form);
                axios
                .post(save_url,this.form)
                .then(response => {
                    // console.log(response);
                    // this.languages = response.data.items;
                    this.validateError.name.error = false;
                    if(whatNext=='more'){
                        this.form.name='';
                        this.form.language='';
                    }else{
                        window.location.href = this.base_url;
                    }
                }).catch(errors => {
                    if(errors.response.data.message){
                        let errorMessage = errors.response.data.message;                                               
                        let fields = Object.keys(this.form);
                        fields.forEach(function(item){
                            // console.log(item);
                            if(typeof errorMessage[item] !='undefined'){
                                me.validateError[item].error = true;
                                me.validateError[item].message = errorMessage[item][0];
                            }
                        });

                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถบันทึกได้ '+ errors.response.data);
                    }
                })
                ;                
            }
        },
    }
</script>